/* OAF 2026-10-30: hide DPO option pictures in Top Shape and Edge fields; show the choices as a plain radio list. */
(function () {
  'use strict';
  var P = ['body #oaf-dpo-inline-slot #itoris_dynamicproductoptions .field.oaf-noimg', 'body #itoris_dynamicproductoptions .field.oaf-noimg'];
  function sel(s) { return P.map(function (p) { return p + ' ' + s; }).join(','); }
  var st = document.createElement('style');
  st.textContent =
    sel('img.itoris-dynamicoptions-thumbnail-image') + ',' + sel('.options-list > .dpo_swatch > img') + '{display:none!important}' +
    sel('.options-list') + '{display:flex!important;flex-wrap:wrap!important;gap:10px!important}' +
    sel('.options-list > .dpo_swatch') + '{flex:0 0 auto!important;flex-direction:row!important;align-items:center!important;width:auto!important;max-width:100%!important;min-height:0!important;padding:0!important;text-align:left!important;margin:0!important;transform:none!important;top:auto!important}' +
    sel('.options-list > .dpo_swatch > label') + '{display:inline-block!important;white-space:nowrap!important;padding:7px 14px!important;border:1px solid #cfc6b8!important;border-radius:6px!important;cursor:pointer!important;background:#fff!important;font-size:15px!important;line-height:1.3!important;margin:0!important;transform:none!important;position:static!important}' +
    sel('.options-list > .dpo_swatch:has(input:checked) > label') + '{border-color:#3d3528!important;box-shadow:inset 0 0 0 1px #3d3528!important;font-weight:600!important}';
  document.head.appendChild(st);
  var RE = /^\s*((top|table)\s+)?shape\b|\bedges?\b/i;
  function tag() {
    var r = document.getElementById('itoris_dynamicproductoptions'); if (!r) return;
    r.querySelectorAll('.field[id^="dynamic_option_id_"]').forEach(function (f) {
      if (f.classList.contains('oaf-noimg')) return;
      var l = f.querySelector(':scope > label'); if (!l) return;
      if (RE.test(l.textContent.replace(/\*/g, ''))) f.classList.add('oaf-noimg');
    });
  }
  function start() {
    tag();
    var mo = new MutationObserver(tag);
    mo.observe(document.body, {childList: true, subtree: true});
    setTimeout(function () { mo.disconnect(); setInterval(tag, 2000); }, 30000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
